import { Paragraph, Wrapper } from "./styles";

export default function TemplatesTableSkeleton() {
  return (
    <Wrapper>
      <Paragraph>Ainda não há modelos de contrato.</Paragraph>
    </Wrapper>
  );
}
